import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-vector-tagging-shape-list-and-tag-editor',
  templateUrl: './vector-tagging-shape-list-and-tag-editor.component.html',
  styleUrls: ['../../annotation-shared/toolbars/toolbar-grid.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VectorTaggingShapeListAndTagEditorComponent {}
